<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="pxiii"></a><span epub:type="pagebreak" id="pagexiii" title="xiii"><a id="key"></a>Some key characters</span></h2>
<p class="para">Several hundred individuals are named in this book. Most feature in only one episode. A number, however, turn up more frequently. They are listed here.</p>
<p class="hang1"><strong>Aldcorn, Andrew</strong> Medical doctor, Oban, active in Free Church famine relief efforts.</p>
<p class="hang"><strong>Allan, John</strong> Grain-dealer, Elgin.</p>
<p class="hang"><strong>Balmer, Thomas</strong> Richmond Estate commissioner, Fochabers.</p>
<p class="hang"><strong>Cameron, Patrick</strong> Elginshire (Moray) Sheriff-Substitute, based Elgin.</p>
<p class="hang"><strong>Coffin, Commissary-General Sir Edward Pine</strong> Senior officer, Commissariat.</p>
<p class="hang"><strong>Colquhoun, William</strong> Inverness-shire Sheriff-Substitute, based Inverness.</p>
<p class="hang"><strong>Currie, Alexander</strong> Sheriff of Banffshire.</p>
<p class="hang"><strong>Davidson, Angus</strong> Cooper, Burghead.</p>
<p class="hang"><strong>Evans-Gordon, Captain Charles</strong> Army officer, 76th Regiment.</p>
<p class="hang"><strong>Falconer, James</strong> Shoemaker, Burghead.</p>
<p class="hang"><strong>Fraser, Andrew</strong> Inverness-shire Sheriff-Substitute, based Fort William.</p>
<p class="hang"><strong>Fraser-Tytler, William</strong> Sheriff of Inverness-shire.</p>
<p class="hang"><strong>Gordon, Colonel John</strong> Owner of Barra, South Uist and Benbecula.</p>
<p class="hang"><strong>Gregg, James</strong> Caithness Sheriff-Substitute, based Wick.</p>
<p class="hang"><strong>Grey, Sir George</strong> Home Secretary.</p>
<p class="hang"><strong>Harney, Julian</strong> Chartist activist and editor.</p>
<p class="hang"><strong>Hope, Lord John</strong> High Court judge.</p>
<p class="hang"><strong>Innes, Cosmo</strong> Sheriff of Elginshire (Moray).</p>
<p class="hang"><strong>Jardine, John</strong> Sheriff of Ross-shire.</p>
<p class="hang"><strong>Lindsay, John</strong> Crown Agent, Edinburgh.</p>
<p class="hang"><strong>Loch, James</strong> Sutherland Estate commissioner and Wick MP.</p>
<p class="hang"><a id="pxiv"></a><span epub:type="pagebreak" id="pagexiv" title="xiv"><strong>MacDonald, Donald</strong> Parish priest, Barra.</span></p>
<p class="hang"><strong>MacKay, John</strong> Procurator Fiscal, Inverness.</p>
<p class="hang"><strong>MacLeod, Alexander</strong> Barra, South Uist and Benbecula factor.</p>
<p class="hang"><strong>MacLeod, John</strong> Church of Scotland minister, Morvern.</p>
<p class="hang"><strong>Main, John</strong> Fisherman, Hopeman.</p>
<p class="hang"><strong>Miller, Hugh</strong> Cromarty-born writer and newspaper editor.</p>
<p class="hang"><strong>Nicolson, Alexander</strong> Church of Scotland minister, Barra.</p>
<p class="hang"><strong>Nicolson, James</strong> Shoemaker, Pulteneytown.</p>
<p class="hang"><strong>Pole, George</strong> Investigating officer, Commissariat.</p>
<p class="hang"><strong>Pringle, John</strong> Banffshire Sheriff-Substitute, based Banff.</p>
<p class="hang"><strong>Rhind, Josiah</strong> Banker and provost, Wick.</p>
<p class="hang"><strong>Rutherfurd, Andrew</strong> Lord Advocate.</p>
<p class="hang"><strong>Shaw, Charles</strong> Inverness-shire Sheriff-Substitute, based Lochmaddy.</p>
<p class="hang"><strong>Simpson, William</strong> Provost of Inverness.</p>
<p class="hang"><strong>Sutherland, Daniel</strong> Fisherman, Hopeman.</p>
<p class="hang"><strong>Thomson, Robert</strong> Sheriff of Caithness.</p>
<p class="hang"><strong>Trevelyan, Charles</strong> Treasury civil servant.</p>
<p class="hang"><strong>Waters, David</strong> Free Church minister, Burghead.</p>
<p class="hang"><strong>Young, John</strong> Fisherman, Hopeman.</p>
<p class="hang"><strong>Young, William</strong> Principal proprietor, Burghead.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// key.vue?917d9888